<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户/供应商管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/client' }">客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>客户详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="base1">
      <h3 class="ntitle">基础信息</h3>
      <ul>
        <li>
          <p>
            <label>客户公司名称：</label><a>{{ form.company }}</a>
          </p>
          <template>
            <div v-for="(item, index) in form.brandList" :key="index">
              <p>
                <label>品牌：</label><a>{{ item.brand }}</a>
              </p>
              <p class="p-grey">
                <label>联系人姓名：</label><a>{{ item.name }}</a>
              </p>
            </div>
          </template>
          <p>
            <label>公司地址：</label><a>{{ form.work_address }}</a>
          </p>
          <p>
            <label>备注：</label><a>{{ form.info }}</a>
          </p>
        </li>
        <li>
          <p></p>
          <template>
            <div v-for="(item, index) in form.brandList" :key="index">
              <p></p>
              <p class="p-grey">
                <label>联系人电话：</label><a>{{ item.phone }}</a>
              </p>
            </div>
          </template>
        </li>
        <li>
          <p></p>
          <template>
            <div v-for="(item, index) in form.brandList" :key="index">
              <p></p>
              <p class="p-grey">
                <label>联系人邮箱：</label><a>{{ item.email }}</a>
              </p>
            </div>
          </template>
        </li>
      </ul>
    </div>

    <div class="base1">
      <h3 class="ntitle">付款信息</h3>
      <ul>
        <li>
          <p>
            <label>付款账户：</label><a>{{ form.pay_company }}</a>
          </p>
          <p>
            <label>银行名称：</label><a>{{ form.pay_bank }}</a>
          </p>
          <p>
            <label>银行账号：</label><a class="hoverlink" @click="clickCopy(form.pay_bank_account)">{{ form.pay_bank_account }}</a>
          </p>
        </li>
        <li>

        </li>
      </ul>
    </div>

    <div class="base1">
      <h3 class="ntitle">工商信息</h3>
      <ul>
        <li>
          <p>
            <label>统一社会信用代码：</label><a>{{ form.company_id_card }}</a>
          </p>
          <p>
            <label>公司注册地址：</label><a>{{ form.reg_address }}</a>
          </p>
          <p>
            <label>公司电话：</label><a>{{ form.company_phone }}</a>
          </p>
          <p>
            <label>附件：</label>
            <template>
              <ul class="bbox">
                <li v-for="(item, index) in fileList" :key="index">
                  <el-col :span="24" v-if="item.origin_name">
                    <el-col :span="20">
                      <div class="origin-name">{{ item.origin_name }}</div>
                    </el-col>
                    <el-col :span="4">
                      <el-link type="primary" style="margin-right:5px" :href="item.httpFile" target="_blank">查看</el-link>
                    </el-col>
                  </el-col>
                </li>
              </ul>
            </template>
          </p>
        </li>
        <li>

        </li>
      </ul>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
export default {
  name: 'clientview',
  data() {
    return {
      nodeLimtList: [],
      form: {
        client_id: '',
        company: '',
        brand_str: '',
        brandList: [
          {
            brand_id: 0,
            brand: '',
            name: '',
            phone: '',
            email: '',
          }
        ],
        work_address: '',
        info: '',
        pay_company: '',
        pay_bank: '',
        pay_bank_account: '',
        company_id_card: '',
        reg_address: '',
        company_phone: '',
        atta_str: {},
        option: '',
      },
      p: 1,
      perPage: 30,
      rules: {},
      fileList: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      del_atta_list: [],
    }
  },
  created() {
    // console.log(this.$route)
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
  },

  watch: {
    ['form.pay_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.pay_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    async getDetail(id) {
      this.checkUrlFn()
      this.$fly
        .post('apiSale_getClientDetail.html', {
          client_id: id,
        })
        .then((res) => {
          let form = res.itemArr
          this.fileList = res.itemArr.fileList.map((item)=> {
            delete item.client_id
            delete item.create_time
            item.flist = []
            return item
          })
          //防空情况
          if (this.fileList.length === 0) {
            this.fileList = [{origin_name: '', file_name: '', httpFile: '', id: '', flist: []}]
          }
          return (this.form = form)
        })
    },
    clickCopy(msg){
      const save = function(e) {
        e.clipboardData.setData('text/plain', msg.replace(/\s*/g,""))
        e.preventDefault() // 阻止默认行为
      }
      const once = {
        once: true
      }
      document.addEventListener('copy', save, once) // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand('copy') // 执行copy方法
      this.$message({ message: '复制成功', type: 'success' })
    }, 
  },
}
</script>

<style lang="scss" scoped>

.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .filterwrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0 0 0 20px;
    }
  }

  .base1 {

    @extend %box;
    margin-bottom: 20px;
    padding: 20px 40px;

    ul {
      padding: 0 25px 0 25px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-flow: row nowrap;
      color: #231f20;
      border-radius: 20px;
      background: #f2f2f2;
      margin-bottom: 20px;
      position: relative;

      li {
        width: 50%;
        font: 14px/3 $font;

        &.full {
          width: 100%;
        }

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          &.p-grey {
            font-weight: 800;
            color: #acacac;
          }
          
          a {
            cursor: default;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }


        }
      }
    }
  }
}
</style>
